import script from "./upload-header-pc.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-header-pc.vue?vue&type=script&setup=true&lang=js"

import "./upload-header-pc.vue?vue&type=style&index=0&id=03f56b62&lang=less"

const __exports__ = script;

export default __exports__